import React from 'react';
import { Countdown } from './Countdown';
import { urgency } from '../data/tables';
export function Urgency() {
  return <section aria-labelledby="urgency-heading" className="bg-ink" data-id="element-237" data-mp="2bvcw8k24uums">
      <div className="mx-auto max-w-content px-5 py-16 text-center sm:px-8 md:py-28" data-id="element-238" data-mp="1wzwvjw71s0hf">
        <h2 id="urgency-heading" className="font-mono text-[11px] uppercase tracking-label text-paper/60" data-id="element-239" data-mp="21y8669562f0p">
          {urgency.kicker}
        </h2>

        <div className="mt-8" data-id="element-240" data-mp="1o50hap8gzxmp">
          <Countdown postCountdownLine={urgency.postCountdown} data-id="element-241" data-mp="1syboirh72gf5" />
        </div>

        <div className="mx-auto mt-14 max-w-[34rem]" data-id="element-242" data-mp="1e8xdzg1vtsy6">
          <div role="progressbar" aria-valuenow={urgency.progress} aria-valuemin={0} aria-valuemax={100} aria-label={urgency.progressLabel} className="h-1.5 w-full bg-paper/15" data-id="element-243" data-mp="1ea8jplew1arx">
            <span className="block h-full bg-brass" style={{
            width: `${urgency.progress}%`
          }} data-id="element-244" data-mp="19acbf9z5qx6k" />
          </div>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-label text-paper/60" data-id="element-245" data-mp="25xfp1460memx">
            {urgency.progressLabel}
          </p>
        </div>
      </div>
    </section>;
}